import { useCallback, useState } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Catalog } from "@/components/Catalog";
import { Maintenance } from "@/components/Maintenance";
import { About } from "@/components/About";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";

export default function Landing() {
  const [prefill, setPrefill] = useState("");
  const inquire = useCallback((g) => {
    setPrefill(g.capacity);
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  }, []);
  const clearPrefill = useCallback(() => setPrefill(""), []);
  return (
    <div className="site">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Catalog onInquire={inquire} />
        <Maintenance />
        <About />
        <Booking prefill={prefill} onPrefilled={clearPrefill} />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
